<template>
  <div>
    application page
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>

</style>
